// import React from "react";

// const Sidebar = ({ activeTab, setActiveTab, onLogout }) => {
//   const menuItems = ["Send", "Receive", "Transactions", "Stored Files"];

//   const styles = {
//     sidebar: {
//       width: "220px",
//       backgroundColor: "#fff",
//       height: "100vh",
//       boxShadow: "2px 0 10px rgba(0,0,0,0.1)",
//       display: "flex",
//       flexDirection: "column",
//       padding: "20px",
//     },
//     logo: {
   
//       color: "#ff3366",
//       marginLeft: '30px',
//       marginBottom: '20px',
//       fontWeight: 'bold',
//       fontSize: '24px',
    
//     },
//  logoImage: {
//   height: '40px',
//   width: 'auto',
//   maxWidth: '200px', // Increased from 120px

//   objectFit: 'contain'
// },
    
//     menuItem: {
//       padding: "12px 15px",
//       borderRadius: "8px",
//       marginBottom: "10px",
//       cursor: "pointer",
//       fontWeight: "500",
//       color: "#333",
//       transition: "background-color 0.3s, color 0.3s",
//     },
//     menuItemActive: {
//       backgroundColor: "#ff3366",
//       color: "#fff",
//     },
//     logout: {
//       padding: "12px 15px",
//       borderRadius: "8px",
//       marginBottom: "10px",
//       cursor: "pointer",
//       fontWeight: "500",
//       color: "#333",
//       backgroundColor: "#f4f4f9",
//       transition: "background-color 0.3s",
//     },
//     logoutHover: {
//       backgroundColor: "#e0e0e0",
//     },
//   };

//   return (
//     <div style={styles.sidebar}>
//       <img src="/images/logo2.png" alt="File Transfer Logo" style={styles.logoImage} />
//       <h2 style={styles.logo}> File Transfer</h2>
//       {menuItems.map((item) => (
//         <div
//           key={item}
//           onClick={() => setActiveTab(item)}
//           style={{
//             ...styles.menuItem,
//             ...(activeTab === item ? styles.menuItemActive : {}),
//           }}
//         >
//           {item}
//         </div>
//       ))}
//       <div
//         onClick={onLogout}
//         style={styles.logout}
//         onMouseOver={(e) => (e.target.style.backgroundColor = styles.logoutHover.backgroundColor)}
//         onMouseOut={(e) => (e.target.style.backgroundColor = styles.logout.backgroundColor)}
//       >
//         Logout
//       </div>
//     </div>
//   );
// };

// export default Sidebar;



// Mobile Responsive Sidebar
import React, { useState } from "react";
import { FaBars } from "@react-icons/all-files/fa/FaBars";
import { FaTimes } from "@react-icons/all-files/fa/FaTimes";

const Sidebar = ({ activeTab, setActiveTab, onLogout }) => {
  const [isOpen, setIsOpen] = useState(false);
  const menuItems = ["Send", "Receive", "Transactions", "Stored Files"];

  const styles = {
    sidebarContainer: {
      position: "relative",
    },
    sidebar: {
      width: "220px",
      backgroundColor: "#fff",
      height: "100vh",
      boxShadow: "2px 0 10px rgba(0,0,0,0.1)",
      display: "flex",
      flexDirection: "column",
      padding: "20px",
      position: "fixed",
      left: 0,
      top: 0,
      zIndex: 1000,
      transition: "transform 0.3s ease",
    },
    sidebarMobile: {
      transform: "translateX(-100%)",
    },
    sidebarOpen: {
      transform: "translateX(0)",
    },
    overlay: {
      display: "none",
      position: "fixed",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      backgroundColor: "rgba(0, 0, 0, 0.5)",
      zIndex: 999,
    },
    overlayActive: {
      display: "block",
    },
    hamburger: {
      display: "none",
      position: "fixed",
      top: "20px",
      left: "20px",
      zIndex: 1001,
      backgroundColor: "#fff",
      border: "none",
      borderRadius: "8px",
      padding: "10px",
      cursor: "pointer",
      boxShadow: "0 2px 8px rgba(0,0,0,0.15)",
      fontSize: "20px",
      color: "#333",
    },
    logo: {
      color: "#ff3366",
      marginLeft: '30px',
      marginBottom: '20px',
      fontWeight: 'bold',
      fontSize: '24px',
    },
    logoImage: {
      height: '40px',
      width: 'auto',
      maxWidth: '200px',
      objectFit: 'contain'
    },
    menuItem: {
      padding: "12px 15px",
      borderRadius: "8px",
      marginBottom: "10px",
      cursor: "pointer",
      fontWeight: "500",
      color: "#333",
      transition: "background-color 0.3s, color 0.3s",
    },
    menuItemActive: {
      backgroundColor: "#ff3366",
      color: "#fff",
    },
    logout: {
      padding: "12px 15px",
      borderRadius: "8px",
      marginBottom: "10px",
      cursor: "pointer",
      fontWeight: "500",
      color: "#333",
      backgroundColor: "#f4f4f9",
      transition: "background-color 0.3s",
  
    },
    logoutHover: {
      backgroundColor: "#e0e0e0",
    },
  };

  const handleMenuClick = (item) => {
    setActiveTab(item);
    setIsOpen(false);
  };

  const handleLogout = () => {
    onLogout();
    setIsOpen(false);
  };

  return (
    <>
      <style>
        {`
          @media (max-width: 768px) {
            .hamburger-btn {
              display: flex !important;
              align-items: center;
              justify-content: center;
            }
            
            .sidebar-mobile {
              transform: translateX(-100%) !important;
            }
            
            .sidebar-open {
              transform: translateX(0) !important;
            }
          }

          @media (max-width: 480px) {
            .sidebar-content {
              width: 200px !important;
            }
            
            .logo-text {
              font-size: 20px !important;
              margin-left: 20px !important;
            }
            
           
          }
        `}
      </style>

      {/* Hamburger Menu Button */}
      <button
        className="hamburger-btn"
        style={styles.hamburger}
        onClick={() => setIsOpen(!isOpen)}
      >
        {isOpen ? <FaTimes /> : <FaBars />}
      </button>

      {/* Overlay */}
      <div
        style={{
          ...styles.overlay,
          ...(isOpen ? styles.overlayActive : {}),
        }}
        onClick={() => setIsOpen(false)}
      />

      {/* Sidebar */}
      <div
        className={`sidebar-content sidebar-mobile ${isOpen ? 'sidebar-open' : ''}`}
        style={styles.sidebar}
      >
        <img 
          src="/images/logo2.png" 
          alt="File Transfer Logo" 
          style={styles.logoImage}
          className="logo-image"
        />
        <h2 style={styles.logo} className="logo-text">File Transfer</h2>
        
        {menuItems.map((item) => (
          <div
            key={item}
            onClick={() => handleMenuClick(item)}
            style={{
              ...styles.menuItem,
              ...(activeTab === item ? styles.menuItemActive : {}),
            }}
          >
            {item}
          </div>
        ))}
        
        <div
          onClick={handleLogout}
          style={styles.logout}
          onMouseOver={(e) => (e.target.style.backgroundColor = styles.logoutHover.backgroundColor)}
          onMouseOut={(e) => (e.target.style.backgroundColor = styles.logout.backgroundColor)}
        >
          Logout
        </div>
      </div>
    </>
  );
};

export default Sidebar;
